export const targetEnum = Object.freeze({
  new: Symbol('new'),
  self: Symbol('self'),
});

export const HASH = 'rlink-router--hash';



// WEBPACK FOOTER //
// ./lib/rlink-router/constants.js